import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import "./OTP.css";
import illustration from "../assets/OTP.jpg";
import config from "../../config";

function OTPPage({ loginHandler }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const user_id = state?.user_id;
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    // Check if all OTP digits are filled
    const otpString = otp.join("");
    if (otpString.length === 4 && !isVerifying) {
      handleVerify();
    }
  }, [otp]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    
    if (value && !/^[0-9]$/.test(value)) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      const nextInput = document.querySelector(`.otp-box:nth-child(${index + 2})`);
      if (nextInput) nextInput.focus();
    }

    if (!value && index > 0) {
      const prevInput = document.querySelector(`.otp-box:nth-child(${index})`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.querySelector(`.otp-box:nth-child(${index})`);
      if (prevInput) prevInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").slice(0, 4);
    if (/^\d{4}$/.test(pasteData)) {
      const newOtp = pasteData.split("");
      setOtp(newOtp);
      
      const lastInput = document.querySelector(`.otp-box:nth-child(${newOtp.length})`);
      if (lastInput) lastInput.focus();
    }
  };

  const handleVerify = async () => {
    const otpString = otp.join("");

    if (otpString.length !== 4 || isNaN(otpString)) {
      alert("Please enter a valid 4-digit OTP.");
      return;
    }

    setIsVerifying(true);

    try {
      const response = await fetch(`${config.API_URL}/auth/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id, otp: otpString }),
      });

      const data = await response.json();

      if (data.token) {
        Cookies.set("authToken", data.token, { expires: 365, path: "/" });
        Cookies.set("userType", data.user_type, { expires: 365, path: "/" });
        Cookies.set("userId", user_id, { expires: 365, path: "/" });

        loginHandler(data.token, data.user_type, user_id);

        if (data.user_type === "management") {
          navigate("/management-dashboard");
        } else if (["TSO Online", "Online TSO"].includes(data.user_type)) {
          navigate("/dashboard");
        } else {
          navigate("/c-dashboard");
        }
      } else {
        alert("Invalid OTP. Please try again.");
        // Clear OTP fields on failure
        setOtp(["", "", "", ""]);
        const firstInput = document.querySelector(".otp-box");
        if (firstInput) firstInput.focus();
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred during OTP verification. Please try again.");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleResend = () => {
    alert("A new OTP has been sent to your registered phone number.");
    // Clear existing OTP when resending
    setOtp(["", "", "", ""]);
    const firstInput = document.querySelector(".otp-box");
    if (firstInput) firstInput.focus();
  };

  return (
    <div className="otp-page-container">
      <div className="container">
        <img
          src={illustration}
          alt="Verification Illustration"
          className="verification-illustration"
        />

        <div className="otp-form">
          <h2>Verification</h2>
          <p>
            Enter the OTP sent to your registered phone number to verify your
            identity.
          </p>

          <div className="otp-container">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="otp-box"
                value={digit}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                autoFocus={index === 0}
                disabled={isVerifying}
              />
            ))}
          </div>

          {isVerifying && <p className="verifying-message">Verifying OTP...</p>}

          <button onClick={handleVerify} className="login-button" disabled={isVerifying}>
            Verify OTP
          </button>

          <p className="resend-code">
            Didn't receive any code?{" "}
            <span onClick={handleResend}>Resend Code</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OTPPage;